<template>
  <div>
    <b-card>
      <p class="m-text-deep">{{ configData.itemTitle}}</p>
      <b-container fluid>
        <div style="display: flex; justify-content: space-between;align-items: center;margin-bottom: 10px">
        <b-form inline>
        {{configData.searchText1}}: &nbsp;&nbsp; <b-input v-model="queryName" />
        </b-form>

        <b-form inline>
          {{configData.searchText2}}: &nbsp;&nbsp; <b-input v-model="queryNumber" />
        </b-form>

        <b-btn @click="search">Search</b-btn>

        <b-form-checkbox v-model="addAllItem" v-show="configData.isShowAddAll" style="margin-left: 4px">Add All</b-form-checkbox>
        </div>
      </b-container>
      <m-loader size="box" :show="!isInitData" />
      <p v-show="itemDatas.length === 0 && isInitData" class="table-notice">There is no available data</p>
      <table class="table" v-show="isInitData">
        <tr>
          <th>{{configData.itemTitle1}}</th>
          <th>{{configData.itemTitle2}}</th>
          <th v-if="configData.itemTitle3">{{configData.itemTitle3}}</th>
          <th v-if="configData.itemTitle4">{{configData.itemTitle4}}</th>
          <th>Action</th>
        </tr>
        <tr v-for="item in itemDatas" class="tr">
          <td class="td">{{item.OrderDate | formatDate('MM/DD/YYYY')}}</td>
          <td class="td">{{item.OrderCode || item.SuppressionDesc || ''}}</td>
          <td class="td" v-if="configData.itemTitle3">{{item.OrderDesc}}</td>
          <td class="td" v-if="configData.itemTitle4">{{item.TotalDesiredQty | numberFormat('', 0)}}</td>
          <td class="td">
            <b-btn @click="addItem(item)"
                   variant="sm"
                   v-show="!item.added"
                   :data-value="item.OrderCode || item.SuppressionDesc || ''"
                   :data-test="`demo-suppression-item-add-${configData.type}`">Add</b-btn></td>
        </tr>
      </table>


      <b-pagination size="sm"
                    :total-rows="totalCount"
                    :per-page="12"
                    v-model="page.PageNumber"
                    @input="getSuppression"></b-pagination>
    </b-card>
    <b-card style="margin-top: 16px">
      <p class="m-text-deep">{{configData.selectedTitle}}</p>
      <table class="table">
        <tr>
          <th width="40%">{{configData.selectItemTitle1}}</th>
          <th width="40%">{{configData.selectItemTitle2}}</th>
          <th width="20%">Action</th>
        </tr>
        <tr v-for="item of suppressions" class="tr">
          <td class="td">{{item.code}}</td>
          <td class="td">{{item.name}}</td>
          <td class="td">
            <b-btn variant="sm"
                   @click = "removeItem(item)"
                   :data-value="item.OrderCode"
                   :data-test="`demo-suppression-item-remove-${configData.type}`">Remove</b-btn>
          </td>
        </tr>
      </table>
      <p class="table-notice" v-show="suppressions.length === 0">Please click add in the above table</p>
    </b-card>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      configData: {
        type: Object
      },
      suppressions: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
        queryName: '',
        queryNumber: '',
        page: {
          PageNumber: 1,
          SortBy: 'OrderDate',
          FetchTotalRecordCount: true,
          PageSize: 12,
          SortDescending: true,
          start: 0,
          TotalRecordCount: 0
        },
        items: [],
        totalCount: 9999,
        addAllItem: false,
        isInitData: false
      }
    },
    created () {
      this.getSuppression()
    },
    watch: {
      addAllItem (val) {
        if (val) {
          this.clearItems()
          for (let item of this.items) {
            this.addItem(item)
          }
        } else {
          this.clearItems()
        }
      }
    },
    computed: {
      listType () {
        return this.$store.state.order.ListType
      },
      itemDatas () {
        if (this.suppressions.length > 0) {
          for (let item of this.items) {
            if (this.configData.isFile) {
              item.added = _.findIndex(this.suppressions, {'SuppressionValue': item['SuppressionValue']}) >= 0
            } else if (this.configData.isGeoSLC) {
              item.added = _.findIndex(this.suppressions, {'GeoKeyCode': item['GeoKeyCode']}) >= 0
            } else {
              item.added = _.findIndex(this.suppressions, {code: item['OrderCode']}) >= 0
            }
          }
          return this.items
        } else {
          for (let item of this.items) {
            item.added = false
          }
          return this.items
        }
      },
      order () {
        return this.$store.state.order
      }
    },
    methods: {
      search () {
        this.page.PageNumber = 1
        this.getSuppression()
      },
      getSuppression () {
        this.isInitData = false
        this.$http.post(this.configData.getItemUrl, {
          accountId: this.order.AccountId || 0,
          listType: this.listType,
          listtype: this.listType,
          orderName: this.queryName,
          orderNumber: this.queryNumber,
          countName: this.queryName,
          countNumber: this.queryNumber,
          pagingOptions: this.page
        }).then(resp => {
          this.items = resp.body.d.DataSource.Items
          this.totalCount = resp.body.d.DataSource.TotalRecordCount
          this.isInitData = true
        }, resp => {
          this.isInitData = true
        })
      },
      addItem (item) {
        if (this.configData.isGeoSLC) {
          this.$set(item, 'added', true)
          item.GeoKeyCode = item.CountId
          item.GeoKeyDesc = item.OrderDesc
          item.GeoType = 24
          this.$store.commit('order/setAllHouseholds')
          this.$store.commit('order/saveKey', ['PhoneOption', '1'])
          this.$store.dispatch('order/changeGeoType', 24)
        }
        this.$store.commit(this.configData.addItemKey, item)
      },
      removeItem (item) {
        this.$store.commit(this.configData.removeItemKey, item)
      },
      clearItems () {
        let key = this.configData.clearItemsKey
        this.$store.commit('order/saveKey', [key, []])
      }
    }
  }
</script>

<style scoped>
  .table {
    font-size: 12px;
  }
  .tr{
    padding: 0;
    height: 32px;
  }
  .td{
    padding: 0;
    padding-left: 12px;
    line-height: 32px;
  }
  .table-notice {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/demo/MSuppressionSelectItem.vue